export const groupCasesByMonth = (cases) => {
    return cases.reduce((acc, currentCase) => {
      if (currentCase.timestamp && typeof currentCase.timestamp.toDate === 'function') {
        const date = currentCase.timestamp.toDate();
        const monthYear = `${date.getMonth() + 1}-${date.getFullYear()}`;
  
        if (!acc[monthYear]) {
          acc[monthYear] = [];
        }
        acc[monthYear].push(currentCase);
      }
      return acc;
    }, {});
  };
  export const calculateAverageRatingsByMonth = (groupedCases) => {
    const averages = {};
    for (const [monthYear, cases] of Object.entries(groupedCases)) {
      const caseAverages = cases.map(c => {
        const totalCaseRatings = c.ratings.reduce((acc, rating) => acc + rating, 0);
        return c.ratings.length > 0 ? totalCaseRatings / c.ratings.length : 0;
      });

      const totalMonthRatings = caseAverages.reduce((acc, avg) => acc + avg, 0);
      const avgMonthRating = caseAverages.length > 0 ? totalMonthRatings / caseAverages.length : 0;
      averages[monthYear] = avgMonthRating.toFixed(2);
    }
    return averages;
};
export const calculateAverageRatingForCase = (caseItem) => {
    if (!caseItem.ratings || caseItem.ratings.length === 0) {
      return 0; 
    }
    const totalRating = caseItem.ratings.reduce((acc, rating) => acc + rating, 0);
    return (totalRating / caseItem.ratings.length).toFixed(2);
  };
export const calculateAverageRatingsForWorker = (workerId, cases) => {
    const workerCases = cases.filter(caseItem => caseItem.attachedWorkers.includes(workerId));

    let totalRatings = [0, 0, 0, 0]; 
    let countRatings = 0;
    
    workerCases.forEach(caseItem => {
        if (caseItem.ratings && caseItem.ratings.length === 4) {
            totalRatings = totalRatings.map((total, index) => total + caseItem.ratings[index]);
            countRatings++;
        }
    });
    if (countRatings === 0) return [0, 0, 0, 0];
    const averageRatings = totalRatings.map(total => total / countRatings);
    console.log(`Average ratings for worker ${workerId}:`, averageRatings);

    return averageRatings;
};

  

